export default __webpack_public_path__ + "static/2-40f7432f3d9016c542ed4e8c9d8348fb.webp";